exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown .dropdown-menu[data-v-0212c47b]{width:350px}.dropdown .dropdown-menu .note[data-v-0212c47b]{overflow-y:auto;max-height:200px}", ""]);

// exports
